export default {
  // Navigation
  nav_home: 'ホーム',
  nav_about: '会社について',
  nav_profile: '会社概要',
  nav_business: '事業内容',
  nav_contact: 'お問い合わせ',

  // Language Switcher
  lang_en: 'English',
  lang_ja: '日本語',
  lang_km: 'ខ្មែរ',

  // Hero
  hero_line1: 'カンボジアと日本を繋ぐ',
  hero_line2: '信頼とビジネスと価値を通じて。',
  hero_desc: 'LAVSTYLE（カンボジア）インターナショナル株式会社は、日本のパートナーと共同設立されたカンボジア拠点の国際企業です。複数の業界で信頼できるビジネスソリューションを提供し、両国の架け橋となっています。',

  // About
  about_label: '会社について',
  about_title: 'カンボジアと日本の架け橋',
  about_desc: 'LAVSTYLE（カンボジア）インターナショナル株式会社は、日本の企業との協力関係を通じてカンボジアに設立されました。国際的な子会社として、クリーンで信頼性の高いビジネス構造を持ち、カンボジアと日本間の越境ビジネスの信頼できる接点として機能しています。プロフェッショナリズム、透明性、卓越性への献身が、私たちのすべての活動の原動力となっています。',

  // Company Profile
  profile_label: '会社概要',
  profile_company: '会社名',
  profile_address: '所在地',
  profile_phone: '電話',
  profile_email: 'メール',
  profile_related: '関連日本企業',

  // Partnership
  partner_label: '日本とのパートナーシップ',
  partner_title: '信頼に基づく企業',
  partner_subtitle: '日カンボジア協力',
  partner_desc: '当社は、それぞれの分野で深い専門知識を持つ日本企業によって共同設立されました。このパートナーシップは、日本の精密さ、品質基準、ビジネス哲学と、カンボジアのダイナミックな市場と成長の可能性を結びつけます。共に、パートナーとクライアントに長期的な価値を創造します。',
  partner_1: 'LAV CO., LTD.',
  partner_2: 'IDO Corporation',
  partner_3: 'SWEEP Fukuoka',

  // Business
  business_label: '事業内容',
  business_desc: '私たちは幅広いビジネス分野で事業を展開し、プロフェッショナルなサービスと国際基準を通じて価値を提供しています。',

  business_1_en: 'Restaurants and late-night food and beverage establishments',
  business_1_ja: 'レストランおよび深夜営業の飲食店',
  business_1_km: 'ភោជនីយដ្ឋាន និង​កន្លែង​លក់​អាហារ និង​ភេសជ្ជៈ​សម្រាប់​ពេល​យប់​ជ្រៅ',

  business_2_en: 'Wholesale and retail of various goods',
  business_2_ja: '各種商品の卸売・小売',
  business_2_km: 'លក់ដុំ និងលក់រាយទំនិញជាច្រើនប្រភេទ',

  business_3_en: 'General construction work; Contracting and agency for various construction works',
  business_3_ja: '一般建設工事、各種建設工事の請負及び代理',
  business_3_km: 'ការងារសំណង់ទូទៅ; ការចុះកិច្ចសន្យា និងភ្នាក់ងារសម្រាប់ការងារសំណង់ផ្សេងៗ',

  business_4_en: 'Cleaning, maintenance, and management of buildings',
  business_4_ja: '建物の清掃、保守、管理',
  business_4_km: 'ការសម្អាត ការថែទាំ និង ការគ្រប់គ្រងអគារ',

  business_5_en: 'Collection and transportation of industrial waste',
  business_5_ja: '産業廃棄物の収集・運搬',
  business_5_km: 'ការប្រមូល និងដឹកជញ្ជូនកាកសំណល់ឧស្សាហកម្ម',

  business_6_en: 'Human resources provision',
  business_6_ja: '人材提供',
  business_6_km: 'ការផ្គត់ផ្គង់ធនធានមនុស្ស',

  business_7_en: 'E-commerce and online information services',
  business_7_ja: '電子商取引およびオンライン情報サービス',
  business_7_km: 'សេវាកម្មព័ត៌មានអនឡាញ និងពាណិជ្ជកម្មអេឡិចត្រូនិក',

  // Strengths
  strengths_label: '選ばれる理由',
  strengths_title: '私たちの強み',
  strength_1_title: '国際的な協力',
  strength_1_desc: '日本企業と共同設立され、すべてのプロジェクトに国際基準と越境の専門知識をもたらします。',
  strength_2_title: '多事業対応力',
  strength_2_desc: '建設、飲食、小売、清掃、廃棄物管理、人材、デジタルサービスまで多様なポートフォリオを展開しています。',
  strength_3_title: '日カンボジアの架け橋',
  strength_3_desc: 'カンボジアと日本間で事業を展開したい企業にとって、信頼できる接点として機能しています。',
  strength_4_title: '信頼できる構造',
  strength_4_desc: 'クリーンな企業統治、透明性のある運営、そして倫理的なビジネス慣行への献身。',
  strength_5_title: '柔軟なサポート',
  strength_5_desc: '異なる業界や規模のクライアントの独自のニーズに合わせてサービスを調整します。',

  // Contact
  contact_label: 'お問い合わせ',
  contact_title: 'お問い合わせ',
  contact_desc: 'お問い合わせやパートナーシップを歓迎します。ビジネスに関するご相談や共同事業について、ぜひお気軽にご連絡ください。',
  contact_email_label: 'メール',
  contact_phone_label: '電話',
  contact_guidance: 'お問い合わせはメールでお願いいたします。2営業日以内にご返信を目指しております。',

  // Footer
  footer_company: 'LAVSTYLE（カンボジア）インターナショナル株式会社',
  footer_tagline: '信頼と価値を通じて、カンボジアと日本を繋ぐ。',
  partner_1_url: 'http://www.lavgroup.biz/',
  partner_2_url: 'https://ido-corp.jp/',
  partner_3_url: 'https://sweep-sue.com/',

  // Footer
  footer_links: 'クイックリンク',
  footer_contact: '連絡先',
  footer_location: '所在地',
  footer_copyright: '© 2025 LAVSTYLE（カンボジア）インターナショナル株式会社 All rights reserved.',
  footer_privacy: 'プライバシーポリシー',
  footer_terms: '利用規約',
};